import axios from 'axios';

import { setAuthCookie } from 'services/authService';
import { PortCoOverridesResponse } from 'components/EditableTable/types';

export const getUserHistoricalCompsData = async () => {
  await setAuthCookie();

  return new Promise<PortCoOverridesResponse>((resolve, reject) => {
    axios
      // .get('/mockData/userHistoricalCompsData.json')
      .get('/api/getUserHistoricalCompsData')
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
